// src/components/nav/main-nav.tsx
'use client';

import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { useAuthStore } from '@/store/auth-store';
import { cn } from '@/lib/utils';

// Main menu items with translation keys
const navItems: { nameKey: string; href: string }[] = [
  { nameKey: 'myEvents', href: '/events' },
  { nameKey: 'myAccount', href: '/profile' },
  { nameKey: 'eventBestPractices', href: '/event-best-practices' },
  { nameKey: 'contact', href: '/help' },
];

export function MainNav() {
  const pathname = usePathname();
  const router = useRouter();
  const t = useTranslations();
  const doLogout = useAuthStore((state) => state.doLogout);

  const handleLogout = async () => {
    doLogout();
    router.push('/');
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white">
      <div className="flex h-20 items-center px-8">
        {/* Embrace for Good Logo */}
        <Link href="/events" className="mr-6">
          <Image
            src="/images/Embrace_for_Good_Black_Logo.png"
            alt="Lincoln Embrace for Good"
            width={200}
            height={60}
            priority
          />
        </Link>

        {/* Navigation Menu */}
        <nav className="flex items-center space-x-6 pt-2">
          {navItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              className={cn(
                'text-sm font-medium text-gray-700 transition-colors hover:text-gray-900',
                pathname === item.href && 'font-semibold text-gray-900'
              )}
            >
              {t(item.nameKey)}
            </Link>
          ))}
        </nav>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="ml-auto cursor-pointer pt-2 text-sm text-gray-600 hover:text-gray-900"
        >
          {t('logout')}
        </button>
      </div>
    </header>
  );
}
